import React from "react";
import {withGoogleMap, GoogleMap, Marker} from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";

const INPUT_STYLE = {
    boxSizing: "border-box",
    MozBoxSizing: "border-box",
    border: "1px solid transparent",
    width: "240px",
    height: "30px",
    marginTop: "10px",
    padding: "0 12px",
    borderRadius: "1px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
};
const INPUT_STYLE_MOBILE = {
    boxSizing: "border-box",
    MozBoxSizing: "border-box",
    border: "1px solid transparent",
    width: "105px",
    height: "30px",
    marginTop: "10px",
    padding: "0 12px",
    borderRadius: "2px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
};


export const PickupSitesMap = withGoogleMap((props) => (
    <GoogleMap
        ref={props.onMapMounted}
        options={{
            panControl:true,
            zoomControl: true,
            scaleControl: true,
            mapTypeId: 'roadmap',
            draggable: true,
            animation: false}
        }
        zoom={!props.zoom ? 12 : props.zoom}/*The zoom is relevant only if fitBounds not called*/
        center={props.center}
        onZoomChanged={props.handleMapZoomChanged}
        onCenterChanged={props.handleMapCenterChanged}>
        {!props.onSearchBoxMounted?undefined:
            <SearchBox
                ref={props.onSearchBoxMounted}
                bounds={props.bounds}
                controlPosition={google.maps.ControlPosition.TOP_LEFT}
                onPlacesChanged={props.onPlacesChanged}>
                <input
                    type="text"
                    placeholder="Zip, Address"
                    style={props.isXs?INPUT_STYLE_MOBILE:INPUT_STYLE}
                />
            </SearchBox>}
        {
            props.markers.map((marker, index) => {
                return (<Marker key={index} position={marker.position}
                                onClick={() => props.handleMarkerClick(marker)}
                                icon={marker.icon}>
                    {marker.showInfo ? props.renderInfoWindow(index, marker) : null}
                </Marker>);
            })
        }
    </GoogleMap>)
);



// WEBPACK FOOTER //
// ./src/components/common/PickupSitesMap.js